import axios, { AxiosError } from 'axios';
import React, { useState } from 'react'
import { useForm, SubmitHandler } from "react-hook-form";
import ErrMsg from './page-essential/ErrMsg';
import { useNavigate } from "react-router-dom";
import ApiResponeMessageBox from '../components/apimessages/ApiResponeMessageBox';

type Inputs = {
    email: string,
    password: string,
};


const Login = () => {
    const navigate = useNavigate();

    const initialApiRes = {
        type: '',
        msg: ''
    }
    const [apiRes, setApiRes] = useState(initialApiRes)


    const [loading, setLoading] = useState(false);


    const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            setLoading(true)
            const res = await axios.post(`${process.env.REACT_APP_API}/user/login`, {
                "email": data.email,
                "password": data.password
            })
            localStorage.setItem('token', res.data.access_tokken)
            //TODO: create dynamic base url using .env
            setTimeout(() => {
                // FIXME:
                window.location.replace('https://cms.ultimatetrekkingnepal.com')
            }, 800);
            setApiRes({
                type: 'success',
                msg: res.data.msg
            })

        } catch (error: any) {
            if (error.response.data) {
                setApiRes({
                    type: 'error',
                    msg: error.response.data.message
                })
            }
            setTimeout(() => {
                setApiRes(initialApiRes)
            }, 3000);
        } finally {
            setLoading(false)
        }
    }
    return (
        <section className="h-screen">

            <div className="px-6 h-full text-gray-800">
                <div
                    className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6"
                >
                    <div
                        className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0"
                    >
                        <img
                            src="http://unblast.com/wp-content/uploads/2020/10/Hiking-Vector-Illustration.jpg"
                            className="w-full"
                            alt="Sample image"
                        />
                    </div>
                    <div className="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
                        {apiRes && <ApiResponeMessageBox type={apiRes.type} msg={apiRes.msg} />}

                        <h1 className="text-4xl mb-2">Welcome to</h1>
                        <h1 className='text-primary-base'>Ultimate Trekking Dashboard</h1>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="flex flex-row items-center justify-center lg:justify-start">

                            </div>

                            <div
                                className="flex items-center my-8  after:flex-1 after:border-t after:border-gray-300 after:mt-0.5"
                            >
                                <p className="text-center font-semibold mr-4 mb-0">Sign in with</p>
                            </div>

                            {/* <!-- Email input --> */}
                            <div className="mb-6">
                                <input
                                    type="email"
                                    className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-primary-base focus:outline-none"
                                    id="exampleFormControlInput2"
                                    placeholder="Email address"
                                    required
                                    {...register("email")}
                                />
                            </div>

                            {/* <!-- Password input --> */}
                            <div className="mb-6">
                                <input
                                    type="password"
                                    className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-primary-base focus:outline-none"
                                    placeholder="Password"
                                    required
                                    {...register("password")}

                                />
                            </div>

                            <div className="flex justify-between items-center mb-6">
                                <div className="form-group form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-primary-base checked:border-primary-base focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                    />
                                    <label className="form-check-label inline-block text-gray-800"
                                    >Remember me</label
                                    >
                                </div>
                                <a href="#!" className="text-gray-800">Forgot password?</a>
                            </div>

                            <div className="text-center lg:text-left">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    {loading ? 'Loading...' : 'Login'}
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Login